import { render, staticRenderFns } from "./GjwSpaceListCard.vue?vue&type=template&id=7a585737&scoped=true"
import script from "./GjwSpaceListCard.vue?vue&type=script&lang=js"
export * from "./GjwSpaceListCard.vue?vue&type=script&lang=js"
import style0 from "./GjwSpaceListCard.vue?vue&type=style&index=0&id=7a585737&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a585737",
  null
  
)

export default component.exports